import { EonUiButton } from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";

const OnboardingPortalRefreshButton = ({
    onClick,
}: {
    onClick: () => void;
}) => {
    const t = useTranslation();
    return (
        <EonUiButton
            icon="reload"
            iconPosition="left"
            rank="secondary"
            size="small"
            text={t("onboardingPortal.refreshBtn")}
            onClick={onClick}
            style={{ flexShrink: 0 }}
        />
    );
};

export default OnboardingPortalRefreshButton;
